import { sirenActions, useSirenEntity } from '~/utility/BinSentry-ui-utility';

export function useOrganizationAncestors({ href, endType, startType, excludeBinsentry = true, includeInitialOrganization = true }) {
  const { entity: organization } = useSirenEntity({ href: href });
  const action = organization?.getAction('get-ancestors');

  const endOrganizationType = endType && action?.getField('endOrganizationType').value.find(({ title }) => title === endType)?.value;
  const startOrganizationType = startType && action?.getField('startOrganizationType').value.find(({ title }) => title === startType)?.value;

  const ancestorsHref = action && sirenActions.parseAction(
    action, { endOrganizationType, startOrganizationType, includeInitialOrganization },
  )?.url?.href;
  const { entity } = useSirenEntity({ href: ancestorsHref });
  const ancestors = entity && entity.getSubEntities('item');
  return {
    ancestors: excludeBinsentry
      ? ancestors?.filter(ancestor => ancestor.getSubEntity('https://api.binsentry.com/rel/organization-type').properties.name !== 'binsentry')
      : ancestors,
  };
}
